/**
 * @description Connect all middlewares
 */

export default [];
